import { ColorMatrix } from "@goodgamestudios/core";

import Container = createjs.Container;

export class FilterHelper {
    public static desaturate(target: Container): void {
        var colorMatrix: ColorMatrix = new ColorMatrix();
        colorMatrix.desaturate();
        target.filters = [colorMatrix.filter];
    }
}
